"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CustomerOrdersModal = void 0;
var AddCustomerOrder = _interopRequireWildcard(require("@ori-events/add-customer-order"));
var AddCustomerOrderFailed = _interopRequireWildcard(require("@ori-events/add-customer-order-failed"));
var BasketUpdated = _interopRequireWildcard(require("@ori-events/basket-updated"));
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _hooks = require("../hooks");
var _logger = require("../logger");
var _FormattedMessage = require("./FormattedMessage");
var _LoadingSpinner = require("./LoadingSpinner");
var _OrderRow = require("./OrderRow");
var _Total = require("./Total");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
const INITIAL_ZERO_VALUE = '0';
const Root = (0, _mui.styled)(_components.Dialog)(({
  theme
}) => ({
  [`& .${_mui.paperClasses.root}.${_mui.paperClasses.root}`]: {
    boxSizing: 'border-box',
    margin: 0,
    maxHeight: `calc(100vh - ${theme.spacing(12)})`,
    maxWidth: 785,
    padding: theme.spacing(8, 0, 2),
    position: 'fixed',
    width: `calc(100vw - ${theme.spacing(12)})`,
    [theme.breakpoints.only('xs')]: {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      bottom: 0,
      minWidth: '100%',
      width: '100%'
    }
  },
  [`& .${_components.dialogClasses.content}`]: {
    overflow: 'hidden'
  }
}));
const ScrollableContent = (0, _mui.styled)(_mui.ScopedCssBaseline)(({
  theme
}) => ({
  background: theme.palette.background.paper,
  height: `calc(100%)`,
  overflowY: 'auto',
  overscrollBehavior: 'contain',
  padding: theme.spacing(0, 4),
  position: 'relative',
  [theme.breakpoints.only('xs')]: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  }
}));
const InfoWrapper = (0, _mui.styled)('div')({
  display: 'flex',
  flexDirection: 'column'
});
const StickyContent = (0, _mui.styled)('div')(({
  theme
}) => ({
  backgroundColor: theme.palette.background.paper,
  top: 0,
  opacity: 0.95,
  position: 'sticky',
  width: '100%',
  zIndex: 1
}));
const ModalInfo = (0, _mui.styled)('div')(({
  theme
}) => ({
  margin: theme.spacing(2, 0, 4),
  [theme.breakpoints.up('md')]: {
    margin: theme.spacing(2, 0, 5),
    textAlign: 'center'
  }
}));
const ModalOrdersAmount = (0, _mui.styled)('div')(({
  theme
}) => ({
  marginBottom: theme.spacing(1),
  paddingBottom: theme.spacing(2),
  borderBottom: `1px solid ${theme.palette.grey[200]}`
}));
const OrderRowWrapper = (0, _mui.styled)('div')({
  marginBottom: 'auto'
});
const BottomInfoWrapper = (0, _mui.styled)('div')({
  marginTop: 'auto'
});
const OrderRowContent = (0, _mui.styled)('div')(({
  theme
}) => ({
  margin: theme.spacing(2, 0)
}));
const SelectedOrdersCountWrapper = (0, _mui.styled)('span')({
  fontWeight: 'bold'
});
const InformationSection = (0, _mui.styled)('div')(({
  theme
}) => ({
  marginTop: theme.spacing(3),
  color: theme.palette.grey[600]
}));
const Hint = (0, _mui.styled)('span')(({
  theme
}) => ({
  fontWeight: 'bold',
  marginRight: theme.spacing(1)
}));
const EditLink = (0, _mui.styled)(_mui.Link)(({
  theme
}) => ({
  display: 'inline-block',
  borderBottom: '2px solid #333',
  alignSelf: 'center',
  textTransform: 'uppercase',
  fontSize: theme.typography.caption.fontSize,
  fontWeight: 'bold',
  textDecoration: 'none',
  [theme.breakpoints.up('md')]: {
    fontSize: theme.typography.body1.fontSize,
    alignSelf: 'flex-start'
  }
}));
const TotalWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  backgroundColor: theme.palette.background.paper,
  bottom: 0,
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  left: theme.spacing(2),
  opacity: 0.95,
  padding: theme.spacing(3, 3, 4, 3),
  position: 'absolute',
  width: `calc(100% - ${theme.spacing(4)})`,
  '&:before': {
    background: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    content: '""',
    height: theme.spacing(1),
    left: 0,
    position: 'absolute',
    right: 0,
    top: theme.spacing(-1)
  },
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    left: theme.spacing(4),
    width: `calc(100% - ${theme.spacing(8)})`
  }
}));
const LinkWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  padding: theme.spacing(5, 0, 18),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(5, 0, 26),
    textAlign: 'center'
  }
}));

// TODO: this is wrong on several levels
const SubmitButton = (0, _mui.styled)(_components.Button)(({
  theme
}) => ({
  width: '100%',
  height: theme.spacing(9),
  lineHeight: `${theme.spacing(6)}px`,
  margin: '0 auto',
  padding: theme.spacing(0, 3),
  border: '2px solid',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontWeight: 'bold',
  [theme.breakpoints.up('md')]: {
    maxWidth: theme.spacing(36),
    height: theme.spacing(7),
    marginRight: 'initial'
  }
}));
const addOrdersToBasket = async orderIds => new Promise((resolve, reject) => {
  const handleReject = event => {
    window.removeEventListener(AddCustomerOrderFailed.Name, handleReject);
    // eslint-disable-next-line @typescript-eslint/no-use-before-define -- handleReject and handleResolve are using each other
    window.removeEventListener(BasketUpdated.Name, handleResolve);
    reject(event.detail.localizedMessage);
  };
  const handleResolve = () => {
    window.removeEventListener(BasketUpdated.Name, handleResolve);
    window.removeEventListener(AddCustomerOrderFailed.Name, handleReject);
    resolve();
  };
  window.addEventListener(BasketUpdated.Name, handleResolve);
  window.addEventListener(AddCustomerOrderFailed.Name, handleReject);
  const dispatchedEvent = new CustomEvent(AddCustomerOrder.Name, {
    detail: {
      orderIds
    }
  });
  window.dispatchEvent(dispatchedEvent);
});
const CustomerOrdersModal = ({
  'data-testid': testId,
  isOpen,
  onClose,
  ordersAmount,
  pendingOrders,
  ordersPageLink
}) => {
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  const [selectedOrdersCount, setSelectedOrdersCount] = (0, _react.useState)(INITIAL_ZERO_VALUE);
  const [totalAmountSelected, setTotalAmountSelected] = (0, _react.useState)(INITIAL_ZERO_VALUE);
  const [totalBp, setTotalBp] = (0, _react.useState)(INITIAL_ZERO_VALUE);
  const [selectedOrderIds, setSelectedOrderIds] = (0, _react.useState)([]);
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [shouldReset, setShouldReset] = (0, _react.useState)(false);
  const closeAndReset = (0, _react.useCallback)(e => {
    onClose(e);
    setShouldReset(prevCheck => !prevCheck);
  }, [setShouldReset, onClose]);
  const handleButtonClick = (0, _react.useCallback)(e => {
    setIsLoading(true);
    addOrdersToBasket(selectedOrderIds).then(() => {
      closeAndReset(e);
    }).catch(error => {
      _logger.mainLogger.error(error, {
        action: 'addOrdersToBasket'
      });
    }).finally(() => {
      setIsLoading(false);
    });
  }, [selectedOrderIds, closeAndReset]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Root, {
    closeAfterTransition: true,
    keepMounted: true,
    "data-testid": `${testId}-wrapper`,
    header: formatMessage('customerOrders'),
    open: isOpen,
    onClose: closeAndReset,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(ScrollableContent, {
        "data-testid": `${testId}-content`,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(InfoWrapper, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(StickyContent, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(ModalInfo, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
                id: "chooseTheCustomerOrders"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ModalOrdersAmount, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
                id: "selectedOrdersCount",
                values: {
                  0: /*#__PURE__*/(0, _jsxRuntime.jsx)(SelectedOrdersCountWrapper, {
                    children: selectedOrdersCount
                  }),
                  1: ordersAmount
                }
              })
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(OrderRowWrapper, {
            children: pendingOrders?.map(item => item && /*#__PURE__*/(0, _jsxRuntime.jsx)(OrderRowContent, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_OrderRow.OrderRow, {
                "data-testid": `${testId}-row-${item.endConsumerOrderId}`,
                name: item.endConsumerName,
                price: item.totalPrice,
                bp: item.totalBp,
                shouldReset: shouldReset,
                setSelectedOrdersCount: setSelectedOrdersCount,
                setTotalAmountSelected: setTotalAmountSelected,
                setTotalBp: setTotalBp,
                rowId: item.endConsumerOrderId,
                priceValue: item.totalPriceValue,
                setSelectedOrderIds: setSelectedOrderIds
              })
            }, item.endConsumerOrderId))
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(BottomInfoWrapper, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(InformationSection, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Hint, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
                  id: "pleaseNote"
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
                id: "rememberToAlwaysContactYourCustomersPersonallyBeforeYouApproveAnyOrders"
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(LinkWrapper, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(EditLink, {
                href: ordersPageLink,
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
                  id: "editCustomerOrders"
                })
              })
            })]
          })]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(TotalWrapper, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Total.Total, {
          "data-testid": `${testId}-totals`,
          totalAmountSelected: totalAmountSelected,
          totalBp: totalBp
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(SubmitButton, {
          "data-testid": `${testId}-submit`,
          disabled: !selectedOrderIds.length,
          onClick: handleButtonClick,
          children: isLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoadingSpinner.LoadingSpinner, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
            id: "add"
          })
        })]
      })]
    })
  });
};
exports.CustomerOrdersModal = CustomerOrdersModal;
var _default = exports.default = CustomerOrdersModal;